import React from "react";
import Modify from "../../../assets/modify.svg"
import IconX from "../../../assets/IconX.svg"
import Delete from "../../../assets/Delete.svg"
import Deactivate from "../../../assets/Deactivete.svg"
import DeactiveModelModal from "./DeactiveModelModal";
import DeleteModelModal from "./DeleteModel";

import { useState } from "react";

function Modal({isOpen, onCloseModal, changeState, modelName, filterData}){

    const [isModalShowed, setIsModalShowed] = useState(false);
    const [IsdeleteModalOpen, setDeleteModalOpen] = useState(false)

    const deleteModalOpen= ()=>{
        setDeleteModalOpen(true)
    }

    const deleteModalClose= ()=>{
        setDeleteModalOpen(false)
        //onCloseModal();
    }

    const isModalDeactiveOpen = () =>{
        setIsModalShowed(true);
     }
 
     const closeDeactiveModal = () =>{
        setIsModalShowed(false);
        //onCloseModal();
     }

    if(!isOpen){
        return null;
    }


    return(
        <div className="fixed"> {/*right-36 top-1*/}
            <div className="bg-white rounded-lg shadow-lg z-10 relative right-40 top-8">
                <div className="flex justify-end mb-2">
                    <button onClick={onCloseModal} className="pt-1 pr-2"><img src={IconX} alt="icon"/> </button> 
                </div>

                <div className="pb-2">
                
                    <div className="pl-5 flex items-center content-center hover:bg-gray-50 h-10">
                        <button className="mr-1">
                            <img src={Modify} alt="icon"/>
                        </button>
                        <button className="flex" onClick={isModalDeactiveOpen}>
                            Modify
                        </button>
                    </div>
                     
                    <div className="px-5 flex content-center hover:bg-gray-50 h-10">
                        <button className="mr-1">
                            <img src={Deactivate} alt="icon" onClick={isModalDeactiveOpen}/>
                        </button>
                        <button className="" onClick={isModalDeactiveOpen}>                          
                            {changeState}
                        </button>   
                    </div>
                        {/* {changeState === "Deactive" ? */}
                            {changeState === 'Deactivate' && isModalShowed && (
                                <div>
                                    <DeactiveModelModal 
                                        modalName={modelName} 
                                        onclose={closeDeactiveModal} 
                                        modelIsOpen={isModalShowed}
                                        oncloseFirstModal={onCloseModal}
                                    />
                                </div>
                             )} 
                   
                    <div className="px-5 flex content-center hover:bg-gray-50 h-10">
                        <button className="mr-1">
                            <img src={Delete} alt="icon" onClick={deleteModalOpen}/>
                        </button>
                        <button className="" onClick={deleteModalOpen}>
                            Delete
                        </button> 
                    </div>

                    {IsdeleteModalOpen && (
                        <div>
                            <DeleteModelModal 
                                modalName={modelName} 
                                onclose={deleteModalClose} 
                                modelIsOpen={IsdeleteModalOpen} 
                                oncloseFirstModal={onCloseModal}
                                // filterData={filterData}
                            />
                        </div>
                    )} 

                </div>
              </div>  
        </div>
    )

}

export default Modal;